import React, { useEffect, useMemo, useRef, useState } from "react";
import {
    Area,
    Bar,
    ComposedChart,
    Legend,
    Line,
    LineChart,
    ReferenceLine,
    ResponsiveContainer,
    Tooltip,
    XAxis,
    YAxis,
} from "recharts";
import { formatter } from "../../utils/formatter";

const CustomLegend = (props: any) => {
  const { payload } = props;

  return (
    <ul className="flex items-center gap-2">
      {payload.map((entry:any, index:number) => (
        <li key={`item-${index}`} className="flex items-center">
            {entry.type === 'line' ? (
              <>
                <svg width="40" height="10">
                  <line x1="0" y1="5" x2="15" y2="5" stroke={entry.color} strokeWidth="2" />
                  <polygon points="20,1 24,5 20,9 16,5" fill={entry.color} />
                  <line x1="25" y1="5" x2="40" y2="5" stroke={entry.color} strokeWidth="2" />
                </svg>
              </>
            ) : (
              <svg width="10" height="10">
                <rect x="0" y="0" width="10" height="10" fill={entry.color} />
              </svg>
            )}
          <span style={{ color: entry.color }} className="ml-2 font-semibold chart-legend">
            {entry.value === "onHand" ? "On Hand (Qty.)" :
             entry.value === "onhand" ? "On Hand (Qty.)" :
             entry.value === "effectivess" ? "Safety Stock (Qty.)" :
             entry.value === "adjusted" ? "Safety Stock (Qty.) + Cycle Stock (Qty.)" :
             entry.value}
          </span>
        </li>
      ))}
    </ul>
  );
};


const BarGraph = (props: any) => {
    const {flag, title, data, dataKey, dataName} = props;
    return (
        <div className="w-[100%] h-[100%] bg-[#FFF] shadow rounded px-[2%] py-[12px] border-[1px] border-[#BEBEBE] flex flex-col">
            <div className="flex justify-between items-center mb-[0.5vw]">
                <span className="text-mainGreen font-semibold chart-title self-start">
                    {title}
                </span>
            </div>
            <div className="flex h-full">
              {<div className="flex-grow h-full">
                  <ResponsiveContainer width={"100%"} height={"100%"}>
                      <ComposedChart data={data} margin={{ top: 20, right: 20, bottom: 0, left: 0 }}>
                          <XAxis 
                            fontSize={"0.8vw"} 
                            dataKey="forecastDate" 
                            stroke="#949494"  />
                          <YAxis stroke="#949494" fontSize={"0.8vw"} tickCount={10} tickFormatter={formatter}
                          interval="equidistantPreserveStart" />
                          <Tooltip content={<CustomTooltip/>} />
                          <Legend
                              content={<CustomLegend />}
                              align="left"
                              verticalAlign="top"
                              iconSize={8}
                              wrapperStyle={{ left: 0, top: 0, marginBottom: "10px" }}
                          />
                          <Bar
                            name={dataName[0]}
                            dataKey={dataKey[0]}
                            stroke="#949494"
                            fill="#949494"
                            stackId="a"
                            maxBarSize={20}
                          />
                          <Bar
                            name={dataName[1]}
                            dataKey={dataKey[1]}
                            stroke="#86BC25"
                            fill="#86BC25"
                            stackId="a"
                            maxBarSize={20}
                          />
                          <Bar
                            name={dataName[2]}
                            dataKey={dataKey[2]}
                            stroke="#62B5E5"
                            fill="#62B5E5"
                            stackId="a"
                            maxBarSize={20}
                          />
                          {flag == 1 && <Line
                            name={dataName[3]}
                            dataKey={dataKey[3]}
                            stroke="#012169"
                            fill="#012169"
                            strokeWidth={2}
                            dot={{ strokeWidth: 1, r: 2 }}
                            activeDot={{ stroke: '#012169', fill: 'white', strokeWidth: 2, r: 4 }}
                          />}
                      </ComposedChart>
                  </ResponsiveContainer>
              </div>}
            </div>
        </div>
    );
}

const CustomTooltip = (props: any) => {
    const { active, payload } = props;
    if (active && payload && payload.length) {
        return (
            <div className="bg-[#fff] border-[1px] border-[#BEBEBE] p-2 rounded rs-bg">
                <p className="text-black text-fs16 font-bold mb-2">
                  <span>{payload[0]?.payload?.forecastDate}</span>
                </p>
                <div className="grid grid-cols-2 gap-2">
                    {payload?.map(($: any) => (
                        <div className="flex flex-col" key={$?.name}>
                            <p className="text-black text-fs14">
                                {$.name}
                            </p>
                            <p style={{ color: $.color }} className="text-black text-fs20 font-bold">
                              {formatter($.value)}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        );
    }
    return null;
};

export default BarGraph;
